import React, { useState } from 'react';
import { graphql } from 'gatsby';
import LitImage from './images/LitImage';
import { Link } from 'gatsby';
const ModularCardGridOverlap = ({ data }) => {
  const [showMore, setShowMore] = useState(false);
  const {
    backgroundColor,
    image,
    secondaryImage,
    thirdImage,
    cardGridCard,
    buttonText,
    buttonPath,
  } = data;
  const cardGridOverlapContentLength = showMore
    ? cardGridCard
    : cardGridCard.slice(0, 7);

  return (
    <div className={`modular-card-grid-overlap-container ${backgroundColor}`}>
      <div className="modular-card-grid-inner modular-padding-large modular-global-width">
        <div className="modular-card-grid-overlap">
          <div className="float-image-first">
            <LitImage image={image} />
          </div>
          <div className="float-image-second">
            <LitImage image={secondaryImage} />
          </div>
          <div className="float-image-third">
            <LitImage image={thirdImage} />
          </div>
          {cardGridOverlapContentLength.map(
            ({ card, gridColumnSpan }, index) => {
              const {
                previewImage,
                title,
                previewText,
                publishedDate,
                slug,
                contentWordCounter,
              } = card[0];
              const readTime = JSON.parse(contentWordCounter);

              return (
                <div className={`${gridColumnSpan}`} key={index}>
                  <div className="card-container">
                    <div className="card-image">
                      <LitImage image={previewImage} />
                    </div>
                    <div className="card-content">
                      <h4 className="card-title">{title}</h4>
                      <div className="modular-paragraph">
                        <p>{previewText}</p>
                      </div>
                      <p className="card-date-salary">
                        <p className="article-card-time">
                          {readTime.readingTime}
                        </p>
                        <span>|</span>
                        {new Date(publishedDate).toLocaleDateString('en-GB')}
                      </p>
                      <Link
                        to={`/blog/${slug}`}
                        className={`${
                          gridColumnSpan === 'one' ? 'button-blue' : 'button'
                        }`}
                      >
                        Read more
                      </Link>
                    </div>
                  </div>
                </div>
              );
            },
          )}
        </div>{' '}
        <div className="button-container">
          <button
            className="modular-text-center"
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            {showMore ? 'Read less' : 'Read more'}
          </button>

          <Link to={buttonPath}>{buttonText}</Link>
        </div>
      </div>
    </div>
  );
};

export default ModularCardGridOverlap;

export const fragment = graphql`
  fragment ModularCardGridOverlap on DatoCmsCardGridOverlap {
    internal {
      type
    }
    backgroundColor
    image {
      gatsbyImageData
    }
    secondaryImage {
      gatsbyImageData
    }
    thirdImage {
      gatsbyImageData
    }
    buttonText
    buttonPath
    cardGridCard {
      gridColumnSpan
      card {
        ... on DatoCmsBlogArticleModel {
          internal {
            type
          }
          id
          slug
          publishedDate
          contentWordCounter
          title
          previewText
          category {
            name
          }
          content {
            value
          }
          previewImage {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
